import {
    WORKDAY_FINISH,
    WORKDAY_FINISH_BREAK,
    WORKDAY_RESET,
    WORKDAY_SET,
    WORKDAY_START,
    WORKDAY_START_BREAK,
    WORKDAY_START_LUNCH
} from '@src/_redux/workday/constants';
import {IReduxWorkdayState} from '@src/@interfaces';
import {DateTime} from '@src/@types/DateTime';

export const resetWorkday = () => ({type: WORKDAY_RESET});
export const setWorkdayDetails = (details: Partial<IReduxWorkdayState>) => ({
    type: WORKDAY_SET,
    payload: {details},
});
export const startWorkday = (startedAt?: DateTime) => ({type: WORKDAY_START, payload: {startedAt}});
export const finishWorkday = (finishedAt?: DateTime) => ({type: WORKDAY_FINISH, payload: {finishedAt}});
export const startWorkdayBreak = () => ({type: WORKDAY_START_BREAK});
export const startWorkdayLunchBreak = () => ({type: WORKDAY_START_LUNCH});
export const finishWorkdayBreak = () => ({type: WORKDAY_FINISH_BREAK});
